import { Link } from 'react-router-dom';
import { articleEntries } from '@/mocks/articles';

export default function ArticleEntry() {
  return (
    <section id="przewodniki" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between mb-12 md:mb-16">
          <div>
            <p className="text-xs md:text-sm font-medium text-accent-600 tracking-wider uppercase mb-2 font-label">
              Artykuły SEO
            </p>
            <h2 className="text-3xl md:text-5xl font-bold font-heading text-foreground-950 leading-tight max-w-2xl">
              Przewodniki SEO
              <br />
              i analizy ekspertów
            </h2>
          </div>
          <div className="mt-4 lg:mt-1 lg:text-right">
            <p className="text-sm md:text-base text-foreground-600 max-w-md">
              Regularnie aktualizowane artykuły, porównania i analizy bezpieczeństwa. Wszystko, co musisz wiedzieć o USFansSpreadsheet.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {articleEntries.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group block bg-white rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 border border-background-200/70"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={article.image}
                  alt={`usfansspreadsheet ${article.title}`}
                  title={`USFansSpreadsheet - ${article.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-semibold text-primary-700 font-label">
                    SEO
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-base md:text-lg font-bold font-heading text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-3">
                  {article.summary}
                </p>
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 whitespace-nowrap">
                  Czytaj więcej
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}